export const SortOrder = {
    asc: "asc",
    desc: "desc"
};

export const ITEMS_PER_PAGE = "25";

export const ITEMS_PER_PAGE_LIST = [
    {label: "5", value: "5"},
    {label: "10", value: "10"},
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "250", value: "250"},
    {label: "500", value: "500"}
];
